/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class CustomColor
 * @hideconstructor
 *
 */
define([
	'underscore',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/CustomColorAPI'
], (_, APIFactory, CustomColorAPI) => {
	class CustomColor {

		constructor() {
			this._api = APIFactory.createAPI(this, [CustomColorAPI]);
			this.providers = [];
		}

		registerProvider(provider) {
			this.providers.push(provider);
		}

		deregisterProvider(provider) {
			const idx = this.providers.findIndex(p => p === provider);
			if ( idx !== -1 ) {
				this.providers.splice(idx, 1);
			}
		}

		getUsedCustomColors() {
			var customColors = [];
			this.providers.forEach((provider) => {
				if ((!provider.isEnabled || provider.isEnabled()) && provider.getCustomColorList) {
					let customColorList = provider.getCustomColorList();
					customColors.push(...customColorList);
				}
			});
			customColors = _.uniq(customColors);
			return customColors;
		}

		getAPI() {
			return this._api;
		}

	}
	return CustomColor;
});
